import { useQuery } from "@tanstack/react-query";
import { httpClient } from "@coworker/http-client";
import { ItemExpectedDeliveryResponse } from "../../types/itemExpectedDeliveryResponse";

async function fetchItemExpectedDelivery(
  itemNo: string,
  storeId: string
): Promise<ItemExpectedDeliveryResponse> {
  return await httpClient.tasks.get<ItemExpectedDeliveryResponse>(
    `/items/item-expected-delivery?itemNo=${encodeURIComponent(itemNo)}&storeId=${encodeURIComponent(storeId)}`
  );
}

export function useItemExpectedDelivery(itemNo: string, storeId: string) {
  return useQuery<ItemExpectedDeliveryResponse>({
    queryKey: ["item", "expected", "delivery", itemNo, storeId],
    queryFn: async () => await fetchItemExpectedDelivery(itemNo, storeId),
    staleTime: 86400000, // 1 day, considered fresh for a day.
    refetchOnWindowFocus: false,
    enabled: !!itemNo && !!storeId, // Only run the query if itemNo and storeId are available
  });
}
